import { get } from 'lodash'
import { alphabeticalSort } from './alphabeticalSort'

// sorts an array of objects by giving an object key
// … called with […].sort(sortByKey('id'))
// … called with […].sort(sortByKey('id', 'DESC')) to get the reverse
export const sortByKey = <T>(key: keyof T, order: 'ASC' | 'DESC' = 'ASC') => {
  return (a: T, b: T) => alphabeticalSort(get(a, key), get(b, key)) * (order === 'ASC' ? 1 : -1)
}
